import { FC } from 'react';
import Modal from 'src/utilities/UILibrary/Feedback/Modal/Modal';
import { ModalProps } from 'src/utilities/UILibrary/Feedback/Modal/modal.interface';
import { Button } from 'src/utilities/UILibrary/UI/Button/Button';
import { ComposedModalWrapper } from './composedModal.styles';

type ButtonsProps = {
  label: string;
  onClick?: () => void;
}[];

type ComposedModal = {
  message?: string;
  messageTitle?: string;
  buttons?: ButtonsProps;
  type: 'error' | 'success';
} & Omit<ModalProps, 'children'>;

const genericMessage = 'La operación se completó con éxito. Gracias por tu paciencia.';
const genericTitle = '¡Éxito!';

const errorUrlImg = 'https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error.png';
const successUrlImg = 'https://finsphera-resources.s3.amazonaws.com/iconoSuccess.png';

export const ComposedModal: FC<ComposedModal> = (props) => {
  const {
    message = genericMessage,
    messageTitle = genericTitle,
    buttons,
    type,
    ...restProps
  } = props;
  const genericSetOfButtons = [
    {
      label: 'Cerrar',
      onClick: restProps.onClose
    }
  ];

  return (
    <ComposedModalWrapper {...restProps}>
      <Modal.Header className="modal-header" isCentered>
        <figure>
          <img src={type === 'error' ? errorUrlImg : successUrlImg} alt="icono de aviso" />
        </figure>
        <h3>{messageTitle}</h3>
      </Modal.Header>
      <Modal.Body isCentered>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        {buttons?.map((button) => (
          <Button key={button.label} size="small" onClick={button.onClick ?? restProps.onClose}>
            {button.label}
          </Button>
        ))}
        {!buttons?.length &&
          genericSetOfButtons.map((button) => (
            <Button key={button.label} size="small" onClick={button.onClick}>
              {button.label}
            </Button>
          ))}
      </Modal.Footer>
    </ComposedModalWrapper>
  );
};
